import { ClassNameProps, OptionalChildrenProps } from "@/types";

/**
 * Defines the visual styles available for the button component.
 */
enum ButtonVariant {
  Primary = "primary",
  Secondary = "secondary",
  Tertiary = "tertiary",
  Locked = "locked",
}

/**
 * Defines how the button content is displayed.
 * "Hug" sizes the button to fit its content, while "Fixed" uses a fixed width.
 * This only applies to TV buttons.
 */
enum ButtonLayouts {
  Hug = "hug",
  Fixed = "fixed",
}

interface BaseButtonProps
  extends ClassNameProps,
    OptionalChildrenProps,
    React.HTMLAttributes<HTMLButtonElement> {
  /**
   * Specifies the visual style of the button.
   * Defaults to Primary.
   */
  variant?: ButtonVariant;

  /**
   * Indicates whether the button is in a disabled state.
   * Defaults to false.
   */
  disabled?: boolean;

  /**
   * Specifies the type of button.
   * Defaults to "button".
   */
  type?: "button" | "submit" | "reset";

  /**
   * Click event handler for the button.
   * Receives the click event as an argument.
   */
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

interface TVButtonProps extends BaseButtonProps {
  layout?: ButtonLayouts;

  /**
   * Indicates whether the button is selected.
   * Defaults to false.
   */
  selected?: boolean;
}

/**
 * Props for the Button component.
 */
type ButtonProps = BaseButtonProps | TVButtonProps;

export { ButtonVariant, ButtonLayouts };
export type { BaseButtonProps, TVButtonProps, ButtonProps };
